function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.5 0L12.2631 6H2.73686L7.5 0Z",
  fill: "#BF3831"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.89161 3.68912L7.5 3.19583L7.10839 3.68912L2.34526 9.68912L1.70153 10.5H2.73686H12.2631H13.2985L12.6547 9.68912L7.89161 3.68912Z",
  fill: "#BF3831",
  stroke: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.5 7L12.2631 13H2.73686L7.5 7Z",
  fill: "white"
});

var SvgUp = function SvgUp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/up.fa960dc5.svg";
export { ForwardRef as ReactComponent };